// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"544":"fde17d2c","580":"9eca34bd","808":"4208fb58"}[chunkId] + ".chunk.js";
};